var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('Dashboard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }